import React, { ReactNode } from 'react';

import classNames from 'classnames';

export const CarveNameRow: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="flex min-h-[36px] justify-between">{children}</div>
);

export const CarveName: React.FC<{
  children: React.ReactNode;
  fullWidth?: boolean;
  className?: string;
}> = ({ children, fullWidth = false, className }) => (
  <div
    className={`${fullWidth ? 'w-full text-left' : 'flex-grow text-right'} p-1.5 pl-3 font-heebo text-base uppercase text-white ${className}`}
  >
    {children}
  </div>
);

export const CarveDetailsContainer: React.FC<{ children: ReactNode }> = ({ children }) => {
  return (
    <div className="flex flex-col rounded-md border border-gray-900 font-heebo text-base text-slate-200">
      {children}
    </div>
  );
};

export const CarveDetailsRow: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="flex min-h-[36px] justify-between border-b border-gray-900 odd:bg-slate-800">
    {children}
  </div>
);

export const CarveDetailsLabel: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="w-1/3 min-w-[100px] border-r border-gray-900 p-1.5 px-3 pr-3 text-left capitalize sm:w-1/4">
    {children}
  </div>
);

export const CarveDetailsValue: React.FC<{
  children: React.ReactNode;
  fullWidth?: boolean;
  className?: string;
}> = ({ children, fullWidth = false, className }) => (
  <div
    className={`${fullWidth ? 'w-full text-left' : 'flex-grow text-right'} p-1.5 pl-3 ${className}`}
  >
    {children}
  </div>
);

export const Subheader: React.FC<{ children: ReactNode }> = ({ children }) => {
  return <div className="font-heebo text-sm text-gray-400">{children}</div>;
};

export const CarveSubheader: React.FC<{
  children: ReactNode;
  className?: string;
}> = ({ children, className }) => {
  return (
    <div
      className={classNames(
        'flex h-8 items-center gap-2 px-2 pb-2 font-heebo text-base text-gray-400',
        className,
      )}
    >
      {children}
    </div>
  );
};

export const CarveActions: React.FC<{ children: ReactNode }> = ({ children }) => {
  return <div className="mb-5 flex gap-4">{children}</div>;
};

export const CarveCardContainer: React.FC<{
  highlight?: boolean;
  children: ReactNode;
  className?: string;
}> = ({ children, highlight = false, className }) => {
  return (
    <div
      className={classNames(
        'min-w-[222px] max-w-[455px] flex-grow rounded-lg border-2 font-heebo text-base transition-colors',
        {
          'border-pink-500 text-pink-300': highlight,
          'border-transparent text-white': !highlight,
        },
        className,
      )}
    >
      {children}
    </div>
  );
};
